import { render, staticRenderFns } from "./AppOrderHistory.vue?vue&type=template&id=4fe8bc54&scoped=true"
import script from "./AppOrderHistory.vue?vue&type=script&lang=js"
export * from "./AppOrderHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe8bc54",
  null
  
)

export default component.exports